import React, { useEffect, useState } from "react";
import AlertTypes from "./AlertTypes";
import AlertEscalation from "./AlertEscalation";
import AlertIndTypes from "./AlertIndTypes";
import AlertIndEscalation from "./AlertIndEscalation";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { useLocation } from "react-router-dom";
import AlertTypesAdmin from "./AlertTypesAdmin";
import AlertEscalationAdmin from "./AlertEscalationAdmin";
import { toast } from "react-toastify";
import AlertTypesAndCamera from "./AlertTypesAndCamera";

const AlertMain = ({ ind, editable, adminType }) => {
  const givenpermissions = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );
  const [selectedItem, setSelectedItem] = useState({});
  const [site, setSite] = useState({});
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [activeTab, setActiveTab] = useState(
    givenpermissions?.includes("CAN-List-KNF_ADMIN_ALERT_TYPE")
      ? "types"
      : givenpermissions?.includes("CAN-List-KNF_CAMERA")
        ? "camera"
        : "escalation",
  );
  const [alertData, setAlertData] = useState([]);
  const [alertDataType, setAlertDataType] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const location = useLocation();
  const data_admin = location?.state?.data;
  const [selected, setSelected] = useState([]);
  const [initialSelected, setInitialSelected] = useState([]);
  const [btn, setBtn] = useState(false);

  let path = location?.pathname;

  console.log("path----->", path);

  console.log("adminType------>", adminType);

  useEffect(() => {
    const stored = localStorage.getItem("types");
    if (stored) {
      setActiveTab(JSON.parse(stored));
    } else {
      setActiveTab("types");
      localStorage.setItem("types", JSON.stringify("types"));
    }
  }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    // localStorage.setItem("types", JSON.stringify(type));
    // setSiteList([]);
    // setSelectedItem({});
    // setSite({});
    // if (!adminType) {
    //   setAlertData([]);
    //   setAlertDatas([]);
    // }
  };

  // console.log("selectedItem", selectedItem);
  // console.log("site", site);

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company_id) => {
    setSelectedItem(company_id);
    let formdata = new FormData();
    formdata.append("company_id", company_id?.value);
    post(URL.ACTIVE_ADMIN_SITE, formdata)
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        } else {
          setSiteList([]);
          setSite({});
          setAlertData([]);
          setAlertDataType([]);
          setAlertDatas([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAlert = (site_id, alert_type) => {
    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id);
      post(URL.ALERT_TYPE_LIST, formdata)
        .then((res) => {
          let temp = [];
          console.log("res", res);

          alert_type?.map((item, ind) => {
            let finder = res?.alert_type?.find((i) => i?.name == item?.name);
            if (finder?.id) {
              temp.push({
                ...item,
                severity: finder?.severity,
              });
            } else {
              temp.push(item);
            }
          });

          if (res?.alert_type?.length > 0) {
            setAlertData(temp);
          } else {
            setAlertData(alert_type);
          }
          setAlertDataType(res?.alert_type);
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertData([]);
    }
  };

  const getAlertCam = (site_id) => {
    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id);
      post(URL.ALERT_TYPE_LIST, formdata)
        .then((res) => {
          if (res?.status == "success") {
            setAlertDataType(res?.alert_type);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertDataType([]);
    }
  };

  const getAlertTypes = (site_id) => {
    setSite(site_id);
    if (site_id) {
      let formdata = new FormData();
      if (adminType) {
        formdata.append("site_id", site_id);
      } else {
        formdata.append("site_id", site_id?.value);
      }

      let url_ = adminType ? URL.ADMIN_ALERT_TYPES : URL.ALERT_TYPE_LIST;

      post(url_, formdata)
        .then((res) => {
          if (res?.alert_type?.length > 0) {
            if (adminType) {
              getAlert(site_id, res?.alert_type);
            } else {
              setAlertData(res?.alert_type);
            }
            if (res?.selected_alert_type_ids?.length > 0) {
              setSelected(res?.selected_alert_type_ids);
              setInitialSelected(res?.selected_alert_type_ids);
            }
          } else {
            setAlertData([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertData([]);
    }
  };

  const getAlertEscalation = (site_id) => {
    setSite(site_id);
    if (site_id) {
      let formdata = new FormData();
      if (adminType) {
        formdata.append("site_id", site_id);
      } else {
        formdata.append("site_id", site_id?.value);
      }

      post(URL.ALERT_ESCALATIONS_LIST, formdata)
        .then((res) => {
          if (res?.alert_escalation?.length > 0) {
            setAlertDatas(res?.alert_escalation);
          } else {
            setAlertDatas([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertDatas([]);
    }
  };

  useEffect(() => {
    // getAlertTypes();
    // getAlertEscalation();
    if (adminType) {
      if (data_admin?.id) {
        getAlertTypes(data_admin?.id);
        getAlertEscalation(data_admin?.id);
      }
    } else {
      getCompanyList();
    }
  }, []);

  console.log("acticeTab", activeTab);

  // console.log("selected", selected);
  console.log("adminType", adminType);

  const selectAlertTypes = () => {
    let formdata = new FormData();
    formdata.append("site_id", data_admin?.id);
    selected?.map((item, ind) => {
      formdata.append(`alert_type_id[${ind}]`, item);
    });
    setBtn(true);

    let url = adminType ? `${URL.UPDATE_ALERT_TYPES}s` : URL.UPDATE_ALERT_TYPES;
    console.log("url----->url", url);
    // return;
    post(url, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          setInitialSelected(selected);
          if (adminType && data_admin?.id) {
            getAlertCam(data_admin?.id);
          }
        } else {
          setSelected(initialSelected);
        }
        setBtn(false);
      })
      .catch((err) => {
        setBtn(false);
        console.log("errResponse", err);
      });
  };

  const handleTabSwich = (event) => {
    getAlertTypes(event);
    getAlertEscalation(event);
  };

  console.log("ind------>", ind);

  return (
    <div className="dashRightView">
      <div className="tab-header d-flex gap-3 mb-3">
        {givenpermissions?.includes("CAN-List-KNF_ADMIN_ALERT_TYPE") && (
          <button
            className={`tab-btn ${activeTab === "types" ? "active" : ""}`}
            onClick={() => handleTab("types")}
          >
            Alert Types
          </button>
        )}
        {givenpermissions?.includes("CAN-List-KNF_ALERT_ESCALATION") && (
          <button
            className={`tab-btn ${activeTab === "escalation" ? "active" : ""}`}
            onClick={() => handleTab("escalation")}
          >
            Alert Escalation Time
          </button>
        )}
        {path == "/sites-view" &&
          givenpermissions?.includes("CAN-List-KNF_CAMERA") && (
            <button
              className={`tab-btn ${activeTab === "camera" ? "active" : ""}`}
              onClick={() => handleTab("camera")}
            >
              Camera
            </button>
          )}
      </div>

      {!ind && (
        <div>
          {activeTab === "types" && (
            <AlertTypes
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              site={site}
              setSite={setSite}
              comapanyList={comapanyList}
              getSiteList={getSiteList}
              siteList={siteList}
              getAlertTypes={handleTabSwich}
              alertData={alertData}
              setAlertData={setAlertData}
            />
          )}
          {activeTab === "escalation" && (
            <AlertEscalation
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              site={site}
              setSite={setSite}
              comapanyList={comapanyList}
              getSiteList={getSiteList}
              siteList={siteList}
              getAlertTypes={handleTabSwich}
              alertData={alertDatas}
              setAlertData={setAlertDatas}
            />
          )}
        </div>
      )}

      {/* {adminType && (
        <div>
          {activeTab === "types" && (
            <AlertTypesAdmin
              site={site}
              alertData={alertData}
              setAlertData={setAlertData}
            />
          )}
          {activeTab === "escalation" && (
            <AlertEscalationAdmin
              site={site}
              alertData={alertDatas}
              setAlertData={setAlertDatas}
            />
          )}
        </div>
      )} */}

      {ind && (
        //  !adminType &&
        <div>
          {activeTab === "types" && (
            <AlertIndTypes
              editable={false}
              alertData={alertData}
              setAlertData={setAlertData}
              selected={selected}
              setSelected={setSelected}
              selectAlertTypes={selectAlertTypes}
              btn={btn}
            />
          )}
          {activeTab === "escalation" && (
            <AlertIndEscalation
              editable={editable}
              site={site}
              alertData={alertDatas}
              setAlertData={setAlertDatas}
            />
          )}
          {activeTab === "camera" && (
            <AlertTypesAndCamera
              editable={true}
              site={site}
              alertData={alertDataType}
              setAlertData={setAlertDataType}
              data={data_admin}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default AlertMain;
